module.exports = __webpack_public_path__ + "static/media/017.236c123f.jpg";